import React from 'react';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import RateTable from '../../../generic-components/rate-tables/rate-table-template-container';
import uuid from 'node-uuid';

const StepTwo = ({
  offersOrExtras,
  onTextFieldChangeWithKeyPath,
  updateTableCell,
  extraRates,
  goToStep,
  saving,
  data,
  clearAddRateSetWizard,
}) => {
  const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  const dataToSave = {
    ...data,
    _id: `new-${uuid.v1()}`,
    nonStandardTemplateType: extraRates.nonStandardTemplateType,
    commissionPercentage: extraRates.commissionPercentage,
    rateType: extraRates.rateType,
    nettCommission: extraRates.nettCommission,
    rates: extraRates.rates,
    taxType: extraRates.taxType,
    currency: extraRates.currency,
    taxInclusion: extraRates.taxInclusion,
  };
  return (
    <div style={{ fontFamily }}>
      <div style={{ padding: '24px 10%' }}>
        <div style={{ marginBottom: '12px' }}>Extra type: <b>{data.extraType}</b></div>
        {data.extraCode ? <div style={{ marginBottom: '12px' }}>Extra code: <b>{data.extraCode}</b></div> : undefined}
        {data.description ? <div style={{ marginBottom: '12px' }}>Description: <b>{data.description}</b></div> : undefined}
        <RateTable
          productType="Non-Accommodation"
          withEditableCell
          rateSet={{ ...extraRates }}
          updateTableCell={updateTableCell}
        />
      </div>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' }}>
        <FlatButton
          label="back"
          secondary
          onTouchTap={() => goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 0 })}
        />
        <FlatButton
          label="Add Another"
          loader={saving}
          hoverColor="none"
          labelStyle={{ fontWeight: '600' }}
          onTouchTap={() => {
            if (dataToSave.ratePackages && dataToSave.ratePackages.length) {
              onTextFieldChangeWithKeyPath({
                keyPath: [],
                value: {
                  offersOrExtras: {
                    ...offersOrExtras,
                    list: [...offersOrExtras.list, dataToSave],
                    selectedId: dataToSave._id,
                    createNew: true,
                  },
                  data: {
                    title: data.title,
                    ratePackages: offersOrExtras.productsArray.map(o => o._id),
                  },
                },
              });
              goToStep({ stepperWizardName: 'addExtraStepper', componentIndex: 0 });
              clearAddRateSetWizard();
            } else {
              window.alert(`Please select at least one room type/product this offer should apply to.`);
            }
          }}
          secondary
        />
      </div>
    </div>);
};

export default StepTwo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/extras/2-step-add-extra.jsx